import React from "react";
import { Route, Switch, useRouteMatch } from "react-router-dom";

import { FabricAppPerkDetails } from "./FabricAppPerkDetails";
import { FabricAppPerksListing } from "./FabricAppPerksListing";

export const FabricAppPerksNav: React.FC<unknown> = () => {
  const { path } = useRouteMatch();

  return (
    <div className={"flex flex-row"}>
      <div className={"flex flex-col w-full px-6"}>
        <Switch>
          <Route path={`${path}/:perkId`}>
            <FabricAppPerkDetails basePath={path} />
          </Route>
          <Route path={`${path}`}>
            <FabricAppPerksListing basePath={path} />
          </Route>
        </Switch>
      </div>
    </div>
  );
};
